import axios from 'axios';
import {
  defaultRequestResolve,
  defaultRequestReject,
  defaultResponseResolve,
  defaultResponseReject,
} from './interceptors';

const baseReq = axios.create({
  baseURL: '/platform/api/v1',
  timeout: 8000
});

baseReq
  .interceptors
  .request
  .use(defaultRequestResolve, defaultRequestReject);

baseReq
  .interceptors
  .response
  .use(defaultResponseResolve, defaultResponseReject);

/**
 * 退出登录
 * @param {Object} data
 */
function logout(data) {
  return baseReq.get(`/idk/passport/logout`, data)
}

const APIs = {
  logout,
}

export default APIs;
